import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appOutsideClick]'
  })
export class OutsideClickDirective {

  @Output()
  appOutsideClick: EventEmitter<MouseEvent> = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onClick(event: MouseEvent): void {
    if((event.target as Element).classList.contains('mdc-button__label')){
      return;
    }

    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.appOutsideClick.emit(event);
    }
  }

  constructor(private elementRef: ElementRef) {}
}
